import React from "react";
import styled from "styled-components";

export const ExclusiveSaleBanner: React.FC<{element: HTMLElement}> = (props) => {
  const {element} = props;
  const imgLink = element.dataset.imagelink;
  const imgSrc = element.dataset.imagesrc;
  const imgAlt = element.dataset.imagealt;

  return (
    <React.Fragment>
      <Banner>
        <a href={imgLink}>
          <img src={imgSrc} alt={imgAlt} />
        </a>
      </Banner>
    </React.Fragment>
  );
};

const Banner = styled.div`
  margin-bottom: 3rem;
`;
